// extracted by mini-css-extract-plugin
module.exports = {"kitI":"kitI_kitI__kJNm_"};